import { View } from 'react-native'
import { styled } from '~/core/styled'

export const Container = styled(View, theme => {
  return {
    base: {
      flexDirection: 'column',
      marginTop: 'auto',
      paddingTop: theme.spacingStackTwopulse,
    },
  }
})
